const TINY_URL_API = "https://tinyurl.com/api-create.php";

export const shortenUrl = async (url: string) => {
  const response = await fetch(
    `${TINY_URL_API}?url=${encodeURIComponent(url)}`
  );

  if (!response.ok) {
    throw new Error(`Shorten URL failed with status ${response.status}`);
  }

  return response.text();
};
